import { jsx as _jsx } from "react/jsx-runtime";
import UserItem from './items/UserItem';
const ListUsers = (listUsersProps) => {
    let highlighted = false;
    if (listUsersProps.highlightedIndex === listUsersProps.index) {
        highlighted = true;
    }
    return (_jsx(UserItem, { profile: listUsersProps.profile, highlighted: highlighted, fromNumberFormat: listUsersProps.fromNumberFormat, user: listUsersProps.user, editUser: listUsersProps.editUser, makeCall: listUsersProps.makeCallClickHandler, canMakeOutBoundCall: listUsersProps.canMakeOutBoundCall, userType: listUsersProps.userType }));
};
export default ListUsers;
